var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRockyLogoSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 45,
    viewBox: "0 0 35 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9879 8.01218C25.9698 7.81456 19.8861 10.0213 15.2917 14.6371L15.1536 14.776H5.49411C3.27654 14.776 2.16658 17.4697 3.73317 19.0436L7.31828 22.6454L5.99055 23.9794C5.12179 24.8522 5.12179 26.2638 5.99055 27.1366L12.95 34.1285C13.8188 35.0013 15.2238 35.0013 16.0926 34.1285L17.4203 32.7946L20.8719 36.2624C22.4408 37.8386 25.1197 36.7211 25.1197 34.4932V25.0592L25.3914 24.7863C29.9857 20.1705 32.1846 14.0584 31.9879 8.01218ZM11.7721 21.1303C10.7372 21.1303 9.89881 20.2881 9.89881 19.2482C9.89881 18.2084 10.7372 17.3662 11.7721 17.3662C12.8072 17.3662 13.6455 18.2084 13.6455 19.2482C13.6455 20.2881 12.8072 21.1303 11.7721 21.1303ZM17.3922 17.3662C18.4272 17.3662 19.2655 18.2084 19.2655 19.2482C19.2655 20.2881 18.4272 21.1303 17.3922 21.1303C16.3571 21.1303 15.5188 20.2881 15.5188 19.2482C15.5188 18.2084 16.3571 17.3662 17.3922 17.3662ZM15.2847 29.1292V26.7766C18.2539 26.7766 20.6705 24.3487 20.6705 21.3656H23.0122C23.0122 25.645 19.5465 29.1292 15.2847 29.1292Z",
    fill: "url(#paint0_linear_5005_109092)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5005_109092",
    x1: 17.5,
    y1: 46.8393,
    x2: 17.5,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRockyLogoSign);
export default __webpack_public_path__ + "static/media/RockyLogoSign.b4bcfa8df4bc49f5f3d5b63d1a490e7f.svg";
export { ForwardRef as ReactComponent };